import { type } from '@ngrx/signals';
import { eventGroup } from '@ngrx/signals/events';
import { User } from '../user';
import { AuthAction } from './auth-store';

export const AuthEvents = eventGroup({
   source: 'Auth',
   events: {
       initializeAction: type<{ action: AuthAction }>(),
       changePassword: type<{ code: string, password: string }>(),
       changePasswordError: type<{ error: unknown }>(),
       changePasswordSuccess: type<void>(),
       confirmRegistration: type<{ code: string }>(),
       confirmRegistrationError: type<{ error: unknown }>(),
       confirmRegistrationSuccess: type<void>(),
       createAccount: type<{ name: string, email: string, password: string, redirect: string }>(),
       createAccountError: type<{ error: unknown }>(),
       createAccountSuccess: type<{ redirect: string }>(),
       login: type<{ email: string, password: string, otp?: string, redirect?: string }>(),
       loginError: type<{ error: unknown }>(),
       loginMfaRequired: type<void>(),
       loginSuccess: type<{ user: User, redirect?: string }>(),
       logout: type<{ redirect?: string }>(),
       logoutError: type<{ error: unknown, redirect?: string }>(),
       logoutSuccess: type<{ redirect?: string }>(),
       resetPassword: type<{ email: string }>(),
       resetPasswordError: type<{ error: unknown }>(),
       resetPasswordSuccess: type<void>(),
   },
});
